import { put, call, all, takeEvery, select, delay } from "redux-saga/effects";
import masterActions from "./action";
import axios from "axios";
// import { API_URL } from "../../utils/constants";
import commonActions from "../common/actions";
import { InternalError, ExternalError } from "../../common/ErrorMessage";
import { getCacheWithExpiry, setCacheWithExpiry, cacheTTL } from "../../utils/CacheHelper";

const masterSaga = function* () {
  yield all([
    yield takeEvery(masterActions.GET_GENDER, getGender),
    yield takeEvery(masterActions.GET_MOTHERTONGUE, getMothertongue),
    yield takeEvery(masterActions.GET_REGION, getRegion),
    yield takeEvery(masterActions.GET_RELIGION, getReligion),
    yield takeEvery(masterActions.GET_NATIONALITY, getNationality),
    yield takeEvery(masterActions.GET_ANNUALINCOME, getAnnualIncome),
    yield takeEvery(masterActions.GET_STATE, getState),
    yield takeEvery(masterActions.GET_DISTRICT, getDistrict),
    yield takeEvery(masterActions.GET_TALUKA, getTaluka),
    yield takeEvery(masterActions.GET_VILLAGE, getVillage),
    yield takeEvery(masterActions.GET_CATEGORY, getCategory),
    yield takeEvery(masterActions.GET_CASTE, getCaste),
    yield takeEvery(masterActions.GET_CASTE_BY_ID, getCasteById),
    yield takeEvery(masterActions.GET_PWD_TYPE, getPwdType),
    yield takeEvery(masterActions.GET_PWDSUB_TYPE, getPwdSubType),
    yield takeEvery(masterActions.GET_BOARD, getBoard),
    yield takeEvery(masterActions.GET_LANGUAGE, getLanguage),
    yield takeEvery(masterActions.GET_ALL_DISTRICT, getAllDistrict),
    yield takeEvery(masterActions.GET_GRIEVANCE, getGrievance),
    yield takeEvery(masterActions.GET_MINORITY, getMinority),
    yield takeEvery(masterActions.GET_DOCUMENT_TYPE, getDocumentType),
    // yield takeEvery(masterActions.GET_STATE_FOR_REGISTRATION, getStateForRegistration),
    yield takeEvery(masterActions.GET_DISTRICT_FOR_REGISTRATION, getDistrictForRegistration),
    yield takeEvery(masterActions.GET_TALUKA_FOR_REGISTRATION, getTalukaForRegistration),
    yield takeEvery(masterActions.GET_VILLAGE_FOR_REGISTRATION, getVillageForRegistration),
    yield takeEvery(masterActions.GET_DISTRICT_FOR_COURSE, getDistrictForCourse),
    yield takeEvery(masterActions.GET_TALUKA_FOR_COURSE, getTalukaForCourse),
    yield takeEvery(masterActions.GET_VILLAGE_FOR_COURSE, getVillageForCourse),
    yield takeEvery(masterActions.GET_SPORT_PARTICIPATION_LEVEL, getSportParticipationLevel),
    yield takeEvery(masterActions.GET_SPORT_RANK, getSportRank),
    yield takeEvery(masterActions.GET_SPORT_NAME, getSportName),
    yield takeEvery(masterActions.GET_SPORT_BODY, getSportBody),
    yield takeEvery(masterActions.GET_MARITAL_STATUS, getMaritalStatus),
    yield takeEvery(masterActions.GET_ORPHAN_TYPE, getOrphanType),
    yield takeEvery(masterActions.GET_EWS_DISTRICT, getEwsDistrict),
    yield takeEvery(masterActions.GET_EWS_TALUKA, getEwsTaluka),
    yield takeEvery(masterActions.GET_CVC_DISTRICT, getCVCDistrict),
    yield takeEvery(masterActions.GET_SSC_SCHOOL_DISTRICT, getSSCDistrict),
    yield takeEvery(masterActions.GET_SSC_SCHOOL_TALUKA, getSSCTaluka),
    yield takeEvery(masterActions.GET_HSC_SCHOOL_DISTRICT, getHSCDistrict),
    yield takeEvery(masterActions.GET_HSC_SCHOOL_TALUKA, getHSCTaluka),
    yield takeEvery(masterActions.GET_AWARDED_CLASS, getAwardedClass),
    yield takeEvery(masterActions.GET_AWARDED_CLASS_BY_ID, getAwardedClassById),
    yield takeEvery(masterActions.GET_GRADUATION_BRANCH_NAME, getGraduationBranchName),
    yield takeEvery(masterActions.GET_GRADUATION_BRANCH_NAME_BY_ID, getGraduationBranchNameById),
    yield takeEvery(masterActions.GET_NCL_AUTHORITY, getNclAuthority),
    yield takeEvery(masterActions.GET_EDUCATION_CLASS, getEducationClass),
    yield takeEvery(masterActions.GET_EDUCATION_STREAM, getEducationStream),
    yield takeEvery(masterActions.GET_ISSUING_AUTHORITY, getIssuingAuthority),
    yield takeEvery(masterActions.GET_G_SPECIALISATION_METHOD, getSpecialisationMethod),
    yield takeEvery(masterActions.GET_G_SPECIALISATION_OR_SUBJECT, getSpecialisationSubject),
    yield takeEvery(masterActions.GET_CET_EXAM_NAME, getCetExamName),
    yield takeEvery(masterActions.GET_OBJECTION_TYPE, getObjectionType),
    yield takeEvery(masterActions.GET_REFERENCE, getReference),

  ]);
};

const getGender = function* () {
  try {
    const cacheKey = 'gender_data';

    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_GENDER,
        payload: cachedData,
      });
    } else {

      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/gender`));
      if (result) {
        yield put({
          type: masterActions.SET_GENDER,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};


const getMinority = function* () {
  try {
    const cacheKey = 'minority_data';
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_MINORITY,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/minority`));
      if (result) {
        yield put({
          type: masterActions.SET_MINORITY,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getMothertongue = function* () {
  try {
    const cacheKey = 'mothertounge_data';
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_MOTHERTONGUE,
        payload: cachedData,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/mothertongue`)
      );
      if (result) {
        yield put({
          type: masterActions.SET_MOTHERTONGUE,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getRegion = function* () {
  try {
    const cacheKey = 'region_data';
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_REGION,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/region`));
      if (result) {
        yield put({
          type: masterActions.SET_REGION,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getReligion = function* () {
  try {
    const cacheKey = 'religion_data';
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_RELIGION,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/religion`));
      if (result) {
        yield put({
          type: masterActions.SET_RELIGION,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getNationality = function* () {
  try {
    const cacheKey = 'nationality_data';
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_NATIONALITY,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/nationality`));
      if (result) {
        yield put({
          type: masterActions.SET_NATIONALITY,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getAnnualIncome = function* () {
  try {
    const cacheKey = 'annualincome_data';
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_ANNUALINCOME,
        payload: cachedData,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/familyincome`)
      );
      if (result) {
        yield put({
          type: masterActions.SET_ANNUALINCOME,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getState = function* () {
  try {
    const cacheKey = 'state_data';
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_STATE,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/state`));
      if (result) {
        yield put({
          type: masterActions.SET_STATE,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getDistrict = function* (action) {
  try {
    const stateid = action.payload;

    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/master/district/by_stateid/${stateid}`)
    );

    if (result?.data?.result) {
      yield put({
        type: masterActions.SET_DISTRICT,
        payload: result.data.result,
      });

      // Cache set bhi hata diya hai
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};


const getTaluka = function* (action) {
  try {
    const districtid = action.payload;

    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/master/taluka/by_districtid/${districtid}`)
    );

    if (result) {
      yield put({
        type: masterActions.SET_TALUKA,
        payload: result?.data?.result,
      });

      // Cache ka set bhi hata diya
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};


const getVillage = function* (action) {
  try {
    const talukaid = action.payload;
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/master/village/by_talukaid/${talukaid}`)
    );

    if (result) {
      yield put({
        type: masterActions.SET_VILLAGE,
        payload: result?.data?.result,
      });

      // Cache set bhi hata diya
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};


const getCategory = function* () {
  try {
    const cacheKey = 'category_data';
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_CATEGORY,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/category`));
      if (result) {
        yield put({
          type: masterActions.SET_CATEGORY,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getCaste = function* () {
  try {
    const cacheKey = 'caste_data';

    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_CASTE,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/caste`));
      if (result) {
        yield put({
          type: masterActions.SET_CASTE,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};
const getCasteById = function* (action) {
  try {

    const categoryId = action?.payload;
    const categoryname = String(action.payload).trim();
    const cacheKey = `castebyid_data_${categoryname}`;
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_CASTE,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/caste/by_categoryid/${categoryId}`));
      if (result) {
        yield put({
          type: masterActions.SET_CASTE,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result?.data?.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getPwdType = function* () {
  try {
    const cacheKey = `pwdtype_data`;

    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_PWD_TYPE,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/pwdtype`));
      if (result) {
        yield put({
          type: masterActions.SET_PWD_TYPE,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result?.data?.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};


const getPwdSubType = function* (action) {
  const { payload } = action
  try {
    const pwdtypename = String(payload).trim();
    const cacheKey = `pwdtypeid_data_${payload?.pwdTypeID}`;
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_PWDSUB_TYPE,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/pwdtype/subtypes/${payload?.pwdTypeID}`));
      if (result) {
        yield put({
          type: masterActions.SET_PWDSUB_TYPE,
          payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
        });
        yield call(setCacheWithExpiry, cacheKey, result?.data?.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};


const getBoard = function* () {
  try {
    const cacheKey = 'board_data';
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_BOARD,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/board`));
      if (result) {
        yield put({
          type: masterActions.SET_BOARD,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getLanguage = function* () {
  try {
    const cacheKey = 'language_data';

    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_LANGUAGE,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/language`));
      if (result) {
        yield put({
          type: masterActions.SET_LANGUAGE,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getAllDistrict = function* () {
  try {
    const cacheKey = 'alldistrict_data';
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_ALL_DISTRICT,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/district`));
      if (result) {
        yield put({
          type: masterActions.SET_ALL_DISTRICT,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getGrievance = function* () {

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const cacheKey = 'grievance_data';


    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_GRIEVANCE,
        payload: cachedData,
      });
    } else {
      const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/grievance`));
      if (result) {
        yield put({
          type: masterActions.SET_GRIEVANCE,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getDocumentType = function* () {
  try {
    const cacheKey = 'documenttype_data';
    const cachedData = yield call(getCacheWithExpiry, cacheKey);
    if (cachedData) {
      yield put({
        type: masterActions.SET_DOCUMENT_TYPE,
        payload: cachedData,
      });
    } else {
    const result = yield call(async() => await axios.get(`${process.env.REACT_APP_API_URL}/master/document`))
    if (result) {
      yield put({ type: masterActions.SET_DOCUMENT_TYPE, payload: result?.data?.result })
     yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
      yield call(ExternalError,result)
    }
  } 
}
catch (err) {
    yield call(InternalError, err)
  }
};

// const getStateForRegistration = function* (data) {
//   const { payload } = data;

//   try {
//     const { stateForReg } = yield select(state => state.masterReducer);
//     const result = yield call(() => axios.get(`${process.env.REACT_APP_API_URL}/master/state`));
//     if (result) {
//       let finalRes;
//       (payload?.type === 'parmanent') ? finalRes = {...stateForReg, parmanent: result?.data?.result} :
//       finalRes = {...stateForReg, corespondence: result?.data?.result}
//       yield put({
//         type: masterActions.SET_STATE_FOR_REGISTRATION,
//         payload: finalRes
//       });
//     }
//   } catch (err) {
//   }
// }
const getDistrictForRegistration = function* (data) {
  const { payload } = data;
  const { stateid, type } = payload;

  try {
    const { districtForReg } = yield select(state => state.masterReducer);
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/master/district/by_stateid/${stateid}`)
    );

    if (result) {
      let finalRes;
      (type === 'parmanent') ? finalRes = { ...districtForReg, parmanent: result?.data?.result } :
        finalRes = { ...districtForReg, corespondence: result?.data?.result }
      yield put({
        type: masterActions.SET_DISTRICT_FOR_REGISTRATION,
        payload: finalRes
      });
      yield call(ExternalError, result)
    }

  } catch (err) {
    yield call(InternalError, err);
  }
};


const getTalukaForRegistration = function* (data) {
  const { payload } = data;
  const { districtid, type } = payload;

  try {
    // Redux ke talukaForReg state ko preserve karenge
    const { talukaForReg } = yield select(state => state.masterReducer);

    // Har baar API se fresh taluka list fetch karenge
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/master/taluka/by_districtid/${districtid}`)
    );
if (result) {
      let finalRes;
      (type === 'parmanent') ? finalRes = { ...talukaForReg, parmanent: result?.data?.result } :
        finalRes = { ...talukaForReg, corespondence: result?.data?.result }
      yield put({
        type: masterActions.SET_TALUKA_FOR_REGISTRATION,
        payload: finalRes
      });
    yield put({
      type: masterActions.SET_TALUKA_FOR_REGISTRATION,
      payload: finalRes,
    });
  }
  } catch (err) {
    yield call(InternalError, err);
  }
};

const getVillageForRegistration = function* (data) {
  const { payload } = data;
  const { talukaid, type } = payload;

  try {
    // Redux me already jo villageForReg hai use preserve karenge
    const { villageForReg } = yield select(state => state.masterReducer);

    // Hamesha fresh API call
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/master/village/by_talukaid/${talukaid}`)
    );
if (result) {
      let finalRes;
      (type === 'parmanent') ? finalRes = { ...villageForReg, parmanent: result?.data?.result } :
        finalRes = { ...villageForReg, corespondence: result?.data?.result }
      yield put({
        type: masterActions.SET_VILLAGE_FOR_REGISTRATION,
        payload: finalRes
      });
      yield call(ExternalError, result)
    }

  } catch (err) {
    yield call(InternalError, err);
  }
};


const getDistrictForCourse = function* (data) {
  const { payload } = data;

  try {
    const { districtForCor } = yield select(state => state.masterReducer);
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/master/district/by_stateid/${payload?.stateid}`)
    );
    if (result) {
      let finalRes;
      (payload?.type === 'parmanent') ? finalRes = { ...districtForCor, parmanent: result?.data?.result } :
        finalRes = { ...districtForCor, corespondence: result?.data?.result }
      yield put({
        type: masterActions.SET_DISTRICT_FOR_COURSE,
        payload: finalRes
      });
      yield call(ExternalError, result)
    }
  } catch (err) {
    yield call(InternalError, err)
  }
}

const getTalukaForCourse = function* (data) {
  const { payload } = data;

  try {
    const { talukaForCor } = yield select(state => state.masterReducer);
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/master/taluka/by_districtid/${payload?.districtid}`)
    );
    if (result) {
      let finalRes;
      (payload?.type === 'parmanent') ? finalRes = { ...talukaForCor, parmanent: result?.data?.result } :
        finalRes = { ...talukaForCor, corespondence: result?.data?.result }
      yield put({
        type: masterActions.SET_TALUKA_FOR_COURSE,
        payload: finalRes
      });
      yield call(ExternalError, result)
    }
  } catch (err) {
    yield call(InternalError, err)


  }
}

const getVillageForCourse = function* (data) {
  const { payload } = data;

  try {
    const { villageForCor } = yield select(state => state.masterReducer);
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/master/village/by_talukaid/${payload?.talukaid}`)
    );
    if (result) {
      let finalRes;
      (payload?.type === 'parmanent') ? finalRes = { ...villageForCor, parmanent: result?.data?.result } :
        finalRes = { ...villageForCor, corespondence: result?.data?.result }
      yield put({
        type: masterActions.SET_VILLAGE_FOR_COURSE,
        payload: finalRes
      });
      yield call(ExternalError, result)
    }
  } catch (err) {
    yield call(InternalError, err)


  }
}

const getSportParticipationLevel = function* () {

  try {
    const cacheKey = 'sportparticipationlevel_data';


    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_SPORT_PARTICIPATION_LEVEL,
        payload: cachedData,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/sportsparticipationlevel`)
      );
      if (result) {
        yield put({
          type: masterActions.SET_SPORT_PARTICIPATION_LEVEL,
          payload: result?.data?.statusCode === 200 ? result?.data?.result : []
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
}

const getSportRank = function* () {

  try {
    const cacheKey = 'sportrank_data';


    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_SPORT_RANK,
        payload: cachedData,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/sportsrank`)
      );
      if (result) {
        yield put({
          type: masterActions.SET_SPORT_RANK,
          payload: result?.data?.statusCode === 200 ? result?.data?.result : []
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
}
const getSportName = function* () {

  try {
    const cacheKey = 'sportname_data';


    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_SPORT_NAME,
        payload: cachedData,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/sports`)
      );
      if (result) {
        yield put({
          type: masterActions.SET_SPORT_NAME,
          payload: result?.data?.statusCode === 200 ? result?.data?.result : []
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }

    }
  } catch (err) {
    yield call(InternalError, err)


  }
}
const getSportBody = function* () {

  try {
    const cacheKey = 'sportbody_data';


    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_SPORT_BODY,
        payload: cachedData,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/sportsbody`)
      );
      if (result) {
        yield put({
          type: masterActions.SET_SPORT_BODY,
          payload: result?.data?.statusCode === 200 ? result?.data?.result : []
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
}
const getMaritalStatus = function* () {

  try {
    const cacheKey = 'maritalstatus_data';


    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_MARITAL_STATUS,
        payload: cachedData,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/maritalstatus`)
      );
      if (result) {
        yield put({
          type: masterActions.SET_MARITAL_STATUS,
          payload: result?.data?.statusCode === 200 ? result?.data?.result : []
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
}

const getOrphanType = function* () {

  try {
    const cacheKey = 'orphantype_data';


    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_ORPHAN_TYPE,
        payload: cachedData,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/orphantype`)
      );
      if (result) {
        yield put({
          type: masterActions.SET_ORPHAN_TYPE,
          payload: result?.data?.statusCode === 200 ? result?.data?.result : []
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
}
const getEwsDistrict = function* () {

  try {
    const cacheKey = 'orphantype_data';


    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_EWS_DISTRICT,
        payload: cachedData,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/district/ewsdistricts`)
      );
      if (result) {
        yield put({
          type: masterActions.SET_EWS_DISTRICT,
          payload: result?.data?.statusCode === 200 ? result?.data?.result : []
        });
        yield call(setCacheWithExpiry, cacheKey, result.data.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)


  }
}



// const getEwsTaluka = function* (data) {
//   const { payload } = data;
//   const cacheKey = `ews_taluka_${payload}`;

//   // 24 hours in ms

//   try {
//     const cachedData = yield call(getCacheWithExpiry, cacheKey);

//     if (cachedData) {
//       yield put({
//         type: masterActions.SET_EWS_TALUKA,
//         payload: cachedData
//       });
//     } else {
//       const result = yield call(() =>
//         axios?.get(`${process.env.REACT_APP_API_URL}/master/taluka/by_districtid/${payload}`)
//       );

//       const talukaList = result?.data?.statusCode === 200 ? result?.data?.result : [];

//       yield put({
//         type: masterActions.SET_EWS_TALUKA,
//         payload: talukaList
//       });

//       if (talukaList.length > 0) {
//         yield call(setCacheWithExpiry, cacheKey, talukaList, cacheTTL);
//       }

//       yield call(ExternalError, result);
//     }

//   } catch (err) {
//     yield call(InternalError, err);
//   }
// };


const getEwsTaluka = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/master/taluka/by_districtid/${payload}`)
    );
    if (result) {
      yield put({
        type: masterActions.SET_EWS_TALUKA,
        payload: result?.data?.statusCode === 200 ? result?.data?.result : []
      });
    }
  } catch (err) {
  }
}

const getCVCDistrict = function* () {
  const cacheKey = 'cvc_district_data';


  try {
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_CVC_DISTRICT,
        payload: cachedData,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/district/ewsdistricts`)
      );
      const districtList = result?.data?.statusCode === 200 ? result?.data?.result : [];

      yield put({
        type: masterActions.SET_CVC_DISTRICT,
        payload: districtList,
      });

      if (districtList.length > 0) {
        yield call(setCacheWithExpiry, cacheKey, districtList, cacheTTL);
      }

      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};

const getSSCDistrict = function* (data) {
  const { payload: stateId } = data;
  const cacheKey = `ssc_district_${stateId}`;
  // 24 hours

  try {
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      // ✅ Use cached data
      yield put({
        type: masterActions.SET_SSC_SCHOOL_DISTRICT,
        payload: cachedData,
      });
    } else {
      // 🔁 Call API if not cached
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/district/by_stateid/${stateId}`)
      );

      const districtList = result?.data?.statusCode === 200 ? result?.data?.result : [];

      // ✅ Dispatch to reducer
      yield put({
        type: masterActions.SET_SSC_SCHOOL_DISTRICT,
        payload: districtList,
      });

      // ✅ Cache it
      if (districtList.length > 0) {
        yield call(setCacheWithExpiry, cacheKey, districtList, cacheTTL);
      }

      yield call(ExternalError, result);
    }

  } catch (err) {
    yield call(InternalError, err);
  }
}
const getSSCTaluka = function* (data) {
  const { payload: districtId } = data;
  const cacheKey = `ssc_taluka_${districtId}`;


  try {
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: masterActions.SET_SSC_SCHOOL_TALUKA,
        payload: cachedData,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/taluka/by_districtid/${districtId}`)
      );
      const talukaList = result?.data?.statusCode === 200 ? result?.data?.result : [];

      yield put({
        type: masterActions.SET_SSC_SCHOOL_TALUKA,
        payload: talukaList,
      });

      if (talukaList.length > 0) {
        yield call(setCacheWithExpiry, cacheKey, talukaList, cacheTTL);
      }

      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};




const getHSCDistrict = function* (data) {
  const { payload: stateId } = data;
  const cacheKey = `hsc_district_${stateId}`;


  try {
    const cached = yield call(getCacheWithExpiry, cacheKey);
    if (cached) {
      yield put({ type: masterActions.SET_HSC_SCHOOL_DISTRICT, payload: cached });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/district/by_stateid/${stateId}`)
      );
      const data = result?.data?.statusCode === 200 ? result.data.result : [];
      yield put({ type: masterActions.SET_HSC_SCHOOL_DISTRICT, payload: data });
      if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};

const getHSCTaluka = function* (data) {
  const { payload: districtId } = data;
  const cacheKey = `hsc_taluka_${districtId}`;

  try {
    const cached = yield call(getCacheWithExpiry, cacheKey);
    if (cached) {
      yield put({ type: masterActions.SET_HSC_SCHOOL_TALUKA, payload: cached });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/taluka/by_districtid/${districtId}`)
      );
      const data = result?.data?.statusCode === 200 ? result.data.result : [];
      yield put({ type: masterActions.SET_HSC_SCHOOL_TALUKA, payload: data });
      if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};


const getGraduationBranchName = function* () {
  const cacheKey = `graduation_branch_list`;

  try {
    const cached = yield call(getCacheWithExpiry, cacheKey);
    if (cached) {
      yield put({ type: masterActions.SET_GRADUATION_BRANCH_NAME, payload: cached });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/graduationbranch`)
      );
      const data = result?.data?.statusCode === 200 ? result.data.result : [];
      yield put({ type: masterActions.SET_GRADUATION_BRANCH_NAME, payload: data });
      if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};

const getGraduationBranchNameById = function* (data) {
  const { payload: id } = data;
  const cacheKey = `graduation_branch_${id}`;

  try {
    const cached = yield call(getCacheWithExpiry, cacheKey);
    if (cached) {
      yield put({ type: masterActions.SET_GRADUATION_BRANCH_NAME, payload: cached });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/graduationbranch/${id}`)
      );
      const data = result?.data?.statusCode === 200 ? result.data.result : [];
      yield put({ type: masterActions.SET_GRADUATION_BRANCH_NAME, payload: data });
      if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};


const getAwardedClass = function* () {
  const cacheKey = `awarded_class_list`;

  try {
    const cached = yield call(getCacheWithExpiry, cacheKey);
    if (cached) {
      yield put({ type: masterActions.SET_AWARDED_CLASS, payload: cached });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/awardedclass`)
      );
      const data = result?.data?.statusCode === 200 ? result.data.result : [];
      yield put({ type: masterActions.SET_AWARDED_CLASS, payload: data });
      if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};

// const getAwardedClassById = function* (data) {
//   const { payload } = data;
//   const cacheKey = `awarded_class_${payload?.type}`;


//   try {
//     const cached = yield call(getCacheWithExpiry, cacheKey);
//     if (cached) {
//       yield put({ type: masterActions.SET_AWARDED_CLASS, payload: cached });
//     } else {
//       const result = yield call(() =>
//         axios.get(`${process.env.REACT_APP_API_URL}/master/awardedclass/${payload}`)
//       );
//       const data = result?.data?.statusCode === 200 ? result.data.result : [];
//       yield put({ type: masterActions.SET_AWARDED_CLASS, payload: data });
//       if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
//       yield call(ExternalError, result);
//     }
//   } catch (err) {
//     yield call(InternalError, err);
//   }
// };

const getAwardedClassById = function* (data) {
  const { payload } = data;

  try {
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/master/awardedclass/${payload}`));
    if (result) {
      yield put({
        type: masterActions.SET_AWARDED_CLASS,
        payload: result?.data?.statusCode === 200 ? result?.data?.result : []
      });
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
}



const getNclAuthority = function* () {
  const cacheKey = `ncl_authority_list`;

  try {
    const cached = yield call(getCacheWithExpiry, cacheKey);
    if (cached) {
      yield put({ type: masterActions.SET_NCL_AUTHORITY, payload: cached });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/nclauthority`)
      );
      const data = result?.data?.statusCode === 200 ? result.data.result : [];
      yield put({ type: masterActions.SET_NCL_AUTHORITY, payload: data });
      if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};

const getEducationClass = function* () {
  const cacheKey = 'education_class';

  try {
    const cachedData = yield call(getCacheWithExpiry, cacheKey);
    if (cachedData) {
      yield put({ type: masterActions.SET_EDUCATION_CLASS, payload: cachedData });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/educationclass`)
      );
      const data = result?.data?.statusCode === 200 ? result.data.result : [];
      yield put({ type: masterActions.SET_EDUCATION_CLASS, payload: data });
      if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};

const getEducationStream = function* () {
  const cacheKey = 'education_stream';

  try {
    const cachedData = yield call(getCacheWithExpiry, cacheKey);
    if (cachedData) {
      yield put({ type: masterActions.SET_EDUCATION_STREAM, payload: cachedData });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/educationstream`)
      );
      const data = result?.data?.statusCode === 200 ? result.data.result : [];
      yield put({ type: masterActions.SET_EDUCATION_STREAM, payload: data });
      if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};

const getIssuingAuthority = function* () {
  const cacheKey = 'issuing_authority';

  try {
    const cachedData = yield call(getCacheWithExpiry, cacheKey);
    if (cachedData) {
      yield put({ type: masterActions.SET_ISSUING_AUTHORITY, payload: cachedData });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/issuinguthority`)
      );
      const data = result?.data?.result || [];
      yield put({ type: masterActions.SET_ISSUING_AUTHORITY, payload: data });
      if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};

const getSpecialisationMethod = function* () {
  const cacheKey = 'g_specialisation_method';

  try {
    const cachedData = yield call(getCacheWithExpiry, cacheKey);
    if (cachedData) {
      yield put({ type: masterActions.SET_G_SPECIALISATION_METHOD, payload: cachedData });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/gspecialedmethodorsubject`)
      );
      const data = result?.data?.statusCode === 200 ? result.data.result : [];
      yield put({ type: masterActions.SET_G_SPECIALISATION_METHOD, payload: data });
      if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};

const getSpecialisationSubject = function* (data) {
  const { payload } = data;

  const cacheKey = `specialisation_subject_${payload?.id}`;

  try {
    const cached = yield call(getCacheWithExpiry, cacheKey);
    if (cached) {
      yield put({
        type: masterActions.SET_G_SPECIALISATION_OR_SUBJECT,
        payload: cached,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/gsecializationorsubject/${payload?.id}`)
      );
      const data = result?.data?.statusCode === 200 ? result.data.result : [];
      yield put({
        type: masterActions.SET_G_SPECIALISATION_OR_SUBJECT,
        payload: data,
      });
      if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};

const getCetExamName = function* () {
  const cacheKey = 'cet_exam_name';

  try {
    // const cached = yield call(getCacheWithExpiry, cacheKey);
    // if (cached) {
    //   yield put({
    //     type: masterActions.SET_CET_EXAM_NAME,
    //     payload: cached,
    //   });
    // } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/cetexamname`)
      );
      const data = result?.data?.statusCode === 200 ? result.data.result : [];
      yield put({
        type: masterActions.SET_CET_EXAM_NAME,
        payload: data,
      });
      // if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    // }
  } catch (err) {
    yield call(InternalError, err);
  }
};

const getObjectionType = function* () {
  const cacheKey = 'objection_type';

  try {
    const cached = yield call(getCacheWithExpiry, cacheKey);
    if (cached) {
      yield put({
        type: masterActions.SET_OBJECTION_TYPE,
        payload: cached,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/objectiontype`)
      );
      const data = result?.data?.statusCode === 200 ? result.data.result : [];
      yield put({
        type: masterActions.SET_OBJECTION_TYPE,
        payload: data,
      });
      if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};

const getReference = function* () {
  const cacheKey = 'reference_list';

  try {
    const cached = yield call(getCacheWithExpiry, cacheKey);
    if (cached) {
      yield put({
        type: masterActions.SET_REFERENCE,
        payload: cached,
      });
    } else {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/master/reference`)
      );
      const data = result?.data?.statusCode === 200 ? result.data.result : [];
      yield put({
        type: masterActions.SET_REFERENCE,
        payload: data,
      });
      if (data.length) yield call(setCacheWithExpiry, cacheKey, data, cacheTTL);
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};


export default masterSaga;